import React from 'react';
import { set } from 'dot-prop-immutable';
import { connect } from 'react-redux';
import { toolFormAttr, toolCollapseAttr, getTypeArr, handleInputType, getLocale } from '@utils/util';
import { SimpleForm as Form, Collapse, Select } from '@whalecloud/fdx';
import CustomInput from '@whalecloud/page-builder-base-components/components/CustomInput';
import { getParentElementWithChildren } from '@whalecloud/page-builder-core/selectors';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';

const { Panel } = Collapse;
const { Option } = Select;

const valueKey = 'data.formItemSettings';
const formKey = 'data.formSettings';

const InputNumberSettings = (props: any) => {
  const messages = getLocale();

  const { updateElement, activateElement, parentElement, element } = props;
  const { data: { formItemSettings = {} } = {} } = element;

  const {
    max,
    min,
    precision,
    step,
  } = formItemSettings;

  const initialValues = {
    max,
    min,
    precision,
    step,
  };

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      const propName = `${valueKey}.${key}`;
      const value = obj[key];
      let newElement;
      if (key === 'type') {
        const getHandle = handleInputType(element, propName, value, parentElement, valueKey, formKey);
        newElement = getHandle?.newElement;
        if (getHandle?.getElement) activateElement({ element: getHandle?.getElement?.id });
      } else {
        newElement = set(element, propName, value);
      }
      updateElement({
        element: newElement,
      });
    });
  };
  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1']}>
      <Panel header={messages.PAGEBUIDER_SETTINGS} key="1">
        <CommonItemSettings allowClearHide />
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_MAX} name="max">
            <CustomInput inputType="inputNumber" />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_MIN} name="min">
            <CustomInput inputType="inputNumber" />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_PRECISION} name="precision">
            <CustomInput inputType="inputNumber" />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_STEP} name="step">
            <CustomInput inputType="inputNumber" />
          </Form.Item>
        </Form>
      </Panel>
    </Collapse>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  activateElement: (payload: any) => {
    dispatch({
      type: 'ui/activateElement',
      payload,
    });
  },
});

export default connect<any, any, any>(
  (state, { element }) => {
    return { parentElement: getParentElementWithChildren(state, element.id) };
  },
  mapDispatchToProps,
)(React.memo(InputNumberSettings));
